import { $can } from '@pendo/permissions';
import { STATUS_TYPES } from '@/orchestrate/journeys/status.constants';
const { ACTIVE } = STATUS_TYPES;

function checkPermission (appId, action, entity = 'guide', source = 'ANY', target = 'ANY') {
    if (!appId || !action) {
        return false;
    }

    return $can(appId)
        .entity(entity)
        .action(action)
        .source(source)
        .target(target);
}

export function canCreateJourney ({ appId, entity, source, target }) {
    return checkPermission(appId, 'create', entity, source, target);
}

export function canUpdateJourney ({ appId, entity, source, target, journey }) {
    source = convertSource(source, journey.status);

    return checkPermission(appId, 'edit', entity, source, target);
}

export function canDeleteJourney ({ appId, entity, source, target, journey }) {
    source = convertSource(source, journey.status);

    return checkPermission(appId, 'remove', entity, source, target);
}

export function canPublishJourney ({ appId, entity, source, target }) {
    return checkPermission(appId, 'publish', entity, source, target);
}

function convertSource (source, journeyStatus) {
    if (!source && journeyStatus === ACTIVE) {
        source = 'public'; /* the equivalent of guide entity to active */
    }

    return source;
}
